import { ChangeDetectionStrategy, Component, inject, input, ViewContainerRef } from '@angular/core';
import { IconComponent } from '@lite-workspace/shared/blocks/icon';
import { HlmButton } from '@lite-workspace/shared/helm-ui/button';
import { OnboardingAnchorDirective } from '@lite-workspace/shared/onboarding-service';
import { ProjectDownloadLauncherService } from './project-download-launcher.service';

@Component({
  selector: 'app-project-download-button',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, HlmButton, OnboardingAnchorDirective],
  template: `
    <!-- якорь: список альбомов → кнопка «Скачать» -->
    <button
      hlmBtn
      type="button"
      variant="outline"
      [onboardingAnchor]="coachAnchor()"
      (click)="onClick()"
      size="action"
      aria-label="Скачать"
      class="relative shrink-0 px-2.5 after:absolute after:inset-x-0 after:-inset-y-2 after:content-['']
             disabled:opacity-50 xl:px-5.5"
    >
      <!-- Label from xl only: on tablets the bar also carries the tabs / nav door and would overflow. -->
      <app-icon name="arrow-down" [size]="15" />
      <span class="hidden xl:inline">Скачать</span>
    </button>
  `,
})
export class ProjectDownloadButtonComponent {
  readonly projectId = input.required<string>();
  /** Подсказка онбординга висит на самой кнопке; решает хозяин — `null` значит «здесь якоря нет». */
  readonly coachAnchor = input<string | null>(null);

  private readonly launcher = inject(ProjectDownloadLauncherService);
  private readonly vcr = inject(ViewContainerRef);

  protected onClick(): void {
    // The launcher opens its dialog on the click itself — no in-button busy state left to show.
    this.launcher.open(this.vcr, this.projectId());
  }
}
